import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { useDismissGuide } from '../hooks/use-dismiss-guide';

interface GuideDismissDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function GuideDismissDialog({ open, onOpenChange }: GuideDismissDialogProps) {
  const { t } = useTranslation('authenticated.onboarding-checklist');
  const dismissGuide = useDismissGuide();

  const handleConfirm = () => {
    dismissGuide.mutate(undefined, {
      onSuccess: () => onOpenChange(false),
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-none">
        <DialogHeader>
          <DialogTitle>{t('dismiss.confirmTitle')}</DialogTitle>
          <DialogDescription>{t('dismiss.confirmDescription')}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('dismiss.cancelButton')}
          </Button>
          <Button variant="destructive" onClick={handleConfirm} disabled={dismissGuide.isPending}>
            {t('dismiss.confirmButton')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
